import styled from 'styled-components'
/**
 * =============================================================
 * STRUCTURAL STYLING
 * =============================================================
 */

export const LayoutWrapper = styled.div`
  display: flex;
  margin: 0 auto;
  width: 100%;
  position: relative;
  ${({ theme }) => theme.mediaWidth.Tablet`
    max-width: 680px;
  `}
  ${({ theme }) => theme.mediaWidth.Desktop`
    max-width: 1360px;
      `}
`

export const LayoutContent = styled.div`
  display: flex;
  margin: 0 auto;
  width: 100%;
  position: relative;
  height: calc(100vh - 72px);
  ${({ theme }) => theme.mediaWidth.Tablet`
    height: calc(100vh - 60px);
  `}
  ${({ theme }) => theme.mediaWidth.Mobile`
    height: calc(100vh - 60px);
  `}
`

// styled wrapper around whole app
export const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

/**
 *  structure for header/navigation sub components
 */
export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 72px;
  margin: 0 auto;
  max-width: 825px;
  & > div {
    display: flex;
    align-items: center;
  }
`
